import React from 'react';
import {
    RemoveMenuItemProps,
    updatePipelineStyles,
} from '../create-or-update-pipeline-helper';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import { MenuItem } from '@biq/apex-ui';
import { Grid, Typography } from '@mui/material';

export const RemoveMenuItem = ({
    index,
    handleRemoveStep,
}: RemoveMenuItemProps): React.JSX.Element => (
    <MenuItem
        key={index}
        sx={updatePipelineStyles.menuItemContainer}
        onClick={(): void => handleRemoveStep(index)}
    >
        <Grid sx={updatePipelineStyles.menuItem}>
            <DisabledByDefaultIcon
                sx={updatePipelineStyles.removeStepIconStyles}
            />
            <Typography sx={updatePipelineStyles.draggableMenuItemStyles}>
                Remove
            </Typography>
        </Grid>
    </MenuItem>
);
